import {LoginAttempt} from '@pt/pt-models';

export class PtCoreUtils {
  static upsertLoginAttempt(username: string, loginAttempts: LoginAttempt[]): LoginAttempt[] {
    const response = loginAttempts?.filter(l => l.username !== username);
    const currentUser = loginAttempts?.find(l => l.username === username);
    if (currentUser) {
      response.push({
        username: currentUser.username,
        attempts: currentUser.attempts + 1
      } as LoginAttempt);
    } else {
      response.push({
        username: username,
        attempts: 1
      } as LoginAttempt);
    }
    return response;
  }
}
